__turbopack_context__.v({
  "className": "poppins_1812898a-module__8d8XlW__className",
  "variable": "poppins_1812898a-module__8d8XlW__variable",
});
